/*
 * @Author: M.D.
 * @Date: 2019-12-10 22:17:39
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
export default {
  userInfo: state => state.user.userInfo,
  memberInfo: state => state.user.memberInfo,
  curLoc: state => state.app.curLoc,
  searchTxt: state => state.app.searchTxt,
  unreadNum: state => state.user.unreadNum
}
